import * as React from "react";
import InvalidateAttributeModal from "./InvalidateAttributeModal";
import { AttributeFormConstants } from "../../../common/Constants";
import { Input, InputNumber, DatePicker, Upload, Button, Icon } from "antd";
import TextArea from "antd/lib/input/TextArea";
import SelectInput from "../../components/app/SelectInput";
import Text from "antd/lib/typography/Text";
import MonthAndYearPicker from "../../components/app/MonthAndYearPicker";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {}

export interface Props {
  formConfigAttribute: IFormConfigQualifierAttribute;
  selectedFormElement: any;
  onClick: any;
  translate: any;
  invalidateAttribute: any;
  hideInvalidateAttributeModal: any;
  invalidateAttributeModalVisible?: any;
  maxNumber: number;
  isSelectedComponent: any;
  width?: number;
}

export default class FormAttributeComponent extends React.Component<
  Props,
  State
> {
  render() {
    const {
      formConfigAttribute,
      onClick,
      translate,
      invalidateAttribute,
      hideInvalidateAttributeModal,
      invalidateAttributeModalVisible,
      maxNumber,
      isSelectedComponent,
      width
    } = this.props;

    const handleOnClickEvent = (e) => {
      onClick(formConfigAttribute);
      e.stopPropagation();
    };

    const renderField = (label: string) => {
      if (
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.CHAR ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_CHAR
      ) {
        return <Input style={{ width }} readOnly />;
      } else if (
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.NUMBER ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.INT ||
        AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_INT
      ) {
        return <InputNumber style={{ width }} readOnly />;
      } else if (
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.DATE ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_DATE
      ) {
        return (
          <DatePicker
            style={{ width: width || "100%" }}
            disabled
            showToday={false}
          ></DatePicker>
        );
      } else if (
        formConfigAttribute.attribute.type ===
        AttributeFormConstants.TYPE_VALUES.DATE_2
      ) {
        return (
          <MonthAndYearPicker
            style={{ width: width || "100%" }}
            translate={translate}
            disabled={true}
          />
        );
      } else if (
        formConfigAttribute.attribute.type ===
        AttributeFormConstants.TYPE_VALUES.CLOB
      ) {
        return (
          <TextArea style={{ width: width || "100%" }} readOnly></TextArea>
        );
      } else if (
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.REFERENCA ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_REFERENCA ||
        formConfigAttribute.attribute.type ===
          AttributeFormConstants.TYPE_VALUES.REFERENCA_2
      ) {
        return (
          <SelectInput
            style={{ width: width || "100%" }}
            showSearch={true}
            allowClear
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            selectOptions={formConfigAttribute.attribute.options}
            notFoundContent={translate("search.no_data")}
          />
        );
      } else if (
        formConfigAttribute.attribute.type ===
        AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA
      ) {
        return <Text>{label}</Text>;
      } else if (
        formConfigAttribute.attribute.type ===
        AttributeFormConstants.TYPE_VALUES.BLOB
      ) {
        return (
          <Upload disabled={true}>
            <Button>
              <Icon type={"upload"} />
              {translate("form_configuration.upload")}
            </Button>
          </Upload>
        );
      }
    };
    const renderInput = () => {
      let label = "";
      if (
        formConfigAttribute.attribute.type ===
        AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA
      ) {
        label =
          formConfigAttribute.name ||
          formConfigAttribute.attribute.attributeName;
      } else {
        label = formConfigAttribute.labelVisible
          ? formConfigAttribute.name
          : "";
      }
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {formConfigAttribute.attribute.type !==
          AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA ? (
            <Text style={{ fontSize: 12 }}>{label}</Text>
          ) : (
            <div />
          )}
          {renderField(label)}
        </div>
      );
    };

    return (
      <div
        className={`form-attribute ${
          isSelectedComponent(formConfigAttribute) && "form-element-selected"
        }`}
        onClick={handleOnClickEvent}
      >
        <div
          className={`${maxNumber !== 1 ? "form-attribute-name-grid" : ""}`}
        ></div>
        <div
          className={`${maxNumber !== 1 ? "form-attribute-input-grid" : ""}`}
        >
          {renderInput()}
        </div>
        <InvalidateAttributeModal
          translate={translate}
          visible={
            invalidateAttributeModalVisible &&
            isSelectedComponent(formConfigAttribute)
          }
          onCancel={() => hideInvalidateAttributeModal()}
          removeAttribute={() => {
            invalidateAttribute(formConfigAttribute);
            hideInvalidateAttributeModal();
          }}
        />
      </div>
    );
  }
}
